import React from 'react'
import axios from 'axios';
function useFetch(url) {

    const myToken = localStorage.getItem('token')
    const myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }

    const [data, setData] = React.useState([])
    const [error, setError] = React.useState(null)
    const [loading, setLoading] = React.useState(false)

    React.useEffect(() => {
        setLoading(true)
        axios.get(url, myHeader)
        .then((res) => {
            setData(res.data)
        })
        .catch((e) => {
            setError({message: e.response.data, status: e.response.status})
        })
        .finally(() => {
            setLoading(false)
        })
    }, [url])

    const reFetch = () => {
        setLoading(true)
        axios.get(url, myHeader)
        .then((res) => {
            setData(res.data)
        })
        .catch((e) => {
            setError({message: e.response.data, status: e.response.status})
        })
        .finally(() => {
            setLoading(false)
        })
    }

    const callPost = (url, payload, callback) => {
        setLoading(true)
        axios.post(url, payload, myHeader)
        .then((res) => {
            callback(res.data)
        })
        .catch((e) => {
            console.log(e)
            setError({message: e.response.data, status: e.response.status})
        })
        .finally(() => {
            setLoading(false)
        })
    }

    const callPut = (url, payload, callback, idKey) => {
        setLoading(true)
        axios.put(url, payload, myHeader)
        .then((res) => {
            callback(res.data, idKey)
        })
        .catch((e) => {
            console.log(e)
            setError({message: e.response.data, status: e.response.status})
        })
        .finally(() => {
            setLoading(false)
        })
    }

    const callDelete = (url, callback, idKey) => {
        setLoading(true)
        axios.delete(url, myHeader)
        .then((res) => {
            if(callback) {
                setLoading(false)
                callback(res.data, idKey)
            }
        })
        .catch((e) => {
            setError({message: e.response.data, status: e.response.status})
        })
        .finally(() => {
            setLoading(false)
        })
    }

    const pushItem = (item) => {
        setData(prev => ([...prev, item]))
    }

    const updateItem = (item, key) => {
        setData(data.map(mappedItem => mappedItem[key] === item[key] ? mappedItem = item : mappedItem))
    }

    const replaceItem = (item) => {
        setData({...item})
    }

    const deleteItem = (item, key) => {
        setData(data.filter(i => i[key] !== item[key]))
    }

    const clearError = (val) => {
        setError(val)
    }

    return {data, error, loading, reFetch, callPost, callPut, callDelete, pushItem, updateItem, replaceItem, deleteItem, clearError}
} 
export default useFetch;